export default "__VITE_ASSET__BE2mZv76__"